require('./organization.less');

import * as _ from 'lodash';
import { Mission } from '../objects/Mission';
import { CalendarPosition } from '../misc/calendarPosition';

angular.module("tromanWeb").controller('OrganizationMissionsController', ['stateService', '$q', 'dialogService', 'sortDialog', 'organizationService', 'organizationState', function (stateService, $q, dialogService, sortDialog, organizationService, organizationState) {

    this.showHistoric = false;
    this.showFuture = true;
    this.organization = null;
    this.mandatePeriod = null;

    this.$onInit = function $onInit() {
        const params = stateService.getParams();

        this.filter = params.filter;
        this.organization = organizationState.organization;
        this.mandatePeriod = organizationService.selectDisplayMandate(this.organization, params.mpid);
        this._initPeriod();
    };

    this.uiOnParamsChanged = function (changed) {
        if (_.has(changed, 'mpid')) {
            this.mandatePeriod = organizationService.selectDisplayMandate(this.organization, changed.mpid);
            this._initPeriod();
        }

        if (_.has(changed, 'filter')) {
            this.filter = changed.filter;
        }
    };

    this._initPeriod = function () {
        if (this.mandatePeriod == null) return;

        this.showHistoric = this.mandatePeriod.calendarPosition === CalendarPosition.Historic;
        this.showFuture = true;
        this._reloadMissions();
    };

    this._reloadMissions = function () {
        if (this.mandatePeriod == null) return;

        this.missionList = null;
        this.warnings = 'warnings';

        organizationService.getMissions(this.mandatePeriod).then(data => {
            this.error = null;
            this.missionList = data;
        }).catch(err => {
            this.error = err;
            this.missionList = null;
        });
    };

    this.getMissions = function () {
        if (this.missionList == null) {
            return;
        } else if (this.warnings === 'overlapping') {
            return this.missionList.overlapping;
        } else if (this.warnings === 'duplicates') {
            return this.missionList.duplicates;
        } else {
            return this.missionList.getMissions(this.showHistoric, this.showFuture);
        }
    };

    this.periodChanged = function periodChanged() {
        stateService.replaceParams({ mpid: this.mandatePeriod?.Id });
    };

    this.filterChanged = function filterChanged() {
        stateService.replaceParams({ filter: this.filter });
    };

    this.edit = function edit(mission) {
        if (!mission.isPlaceholder()) {
            dialogService.editMission(mission, this.missionList.getActualMissions())
                .then(() => this._reloadMissions());
        }
    };

    this.canAddMission = function canAddMission() {
        return this.mandatePeriod != null;
    };

    this.addMission = function addMission(mission) {
        if (!this.canAddMission()) return;

        var toadd = new Mission();
        toadd.MandatePeriod = this.mandatePeriod;
        toadd.EnableMunicipalityCheck = !_.isEmpty(this.organization.ValidMunicipalities);
        toadd.AllowPolitikerRegistration = this.organization.AllowPolitikerRegistration;
        if (mission && mission.isPlaceholder()) {
            toadd.OrderNumber = mission.OrderNumber;
        }

        dialogService.editMission(toadd, this.missionList.getActualMissions())
            .then(() => this._reloadMissions());
    };

    this.addMandatePeriod = function addMandatePeriod() {
        var mp = organizationService.nextMandate(this.organization);
        dialogService.editMandatePeriod(mp).then(() => {
            stateService.reload('organization');
        });
    };

    this.canEditMandatePeriod = function canEditMandatePeriod() {
        return this.mandatePeriod != null;
    };

    this.editMandatePeriod = function editMandatePeriod() {
        if (!this.canEditMandatePeriod()) return;
        dialogService.editMandatePeriod(this.mandatePeriod).then(() => {
            stateService.reload('organization');
        });
    };

    this.canUpdateSelected = function canUpdateSelected() {
        return this.missionTable != null && this.missionTable.selectionCount > 0;
    };

    this.updateSelected = function updateSelected() {
        if (!this.canUpdateSelected()) return;

        var missions = this.missionTable.selectedItems();
        if (missions.length <= 0)
            return;

        dialogService.updateOrganizationMissions(missions, this.organization)
            .then(() => this._reloadMissions());
    };

    this.canCreateList = function () {
        return this.missionTable != null && this.missionTable.selectionCount > 0;
    };

    this.createList = function createList() {
        if (!this.canCreateList()) return;

        var list = this.missionTable.selectedItems();
        dialogService.createMissionList(list);
    };

    this.canCreateEmails = function () {
        return this.missionTable != null && this.missionTable.selectionCount > 0;
    };

    this.createEmails = function createEmails() {
        if (!this.canCreateEmails()) return;

        var list = this.missionTable.selectedItems()
            .map(x => x.Person)
            .filter(x => x != null);
        dialogService.createEmailList(list);
    };

    this.canAddToMissionGroup = function canAddToMissionGroup() {
        return this.missionTable != null && this.missionTable.selectionCount > 0;
    };

    this.addToMissionGroup = function addToMissionGroup() {
        if (!this.canAddToMissionGroup()) return;

        var list = this.missionTable.selectedItems();
        dialogService.addToMissionGroup(list);
    };

    this.canChangeSorting = function canChangeSorting() {
        return this.missionList != null && this.missionList.hasNonHistoric && this.mandatePeriod != null;
    };

    this.changeSorting = function changeSorting() {
        if (!this.canChangeSorting()) return;
        sortDialog.sortMissions($q.when(this.missionList.findMissions(false, true)), this.mandatePeriod)
            .then(() => this._reloadMissions());
    };

    this.canSelectMission = function canSelectMission(mission) {
        return !mission.isPlaceholder();
    };

    this.getMissionClass = function getMissionClass(mission) {
        switch (mission.calendarPosition) {
            case CalendarPosition.Historic: return 'mission-historic';
            case CalendarPosition.Active: return 'mission-active';
            case CalendarPosition.Future: return 'mission-future';
            default: return 'mission-placeholder';
        }
    };

    this.selectOrdinary = function selectOrdinary() {
        this.missionTable.selectFiltered(x => !x.MissionType.IsSubstitute);
    };
}]);
